import {
    Box,
    Flex,
    HStack,
    Image,
    Step,
    StepDescription,
    StepIndicator,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    Text,
    Textarea,
  } from "@chakra-ui/react";
  import React, { useEffect, useState } from "react";
import { FetchDoctorAssessmentDetails, UpdateDiagnosis } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import DatePicker from "../../components/date-picker";
import { format, set } from "date-fns";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import AssessmentAudioManager from "../../components/patient-health/doctor-notes/assessmentaudiomanager";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
  
  const DoctorAssessment = ({id,backFunction,doctorId,appointmentid}) => {

  const [patientid, setPatientid] = useState("");
  const [doctorAssessmentData, setDoctorAssessmentData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const addDiagnosisRef = React.useRef(null);
  const editDiagnosisRef = React.useRef(null);
  const deleteDiagnosisRef = React.useRef(null);
  const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  const [time, setTime] = useState(moment().format("HH:mm"));
  const { showSuccessToast, showErrorToast } = Toaster();
  var [DoctorList, setDoctorList] = useState([]);
  var [doctorData, setDoctorData] = useState([]);
  var [DefaultDoctor, setDefaultDoctor] = useState(null);
  const [formInputs, setFormInputs] = useState([
    { diagnosisid: null, diagnosis: "", plan: "" },
  ]);
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  
  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?') [1]);
    const id = searchParams.get('id');
    setPatientid(id);
    if (appointmentid) {
      fetchdoctorassessmentdata(id , appointmentid);
    } else {
      fetchdoctorassessmentdata(id)
    }
  }, []);
  
  const fetchdoctorassessmentdata = async (id,appointmentid) => {
    showLoader()
      try {
        const result = await FetchDoctorAssessmentDetails({
          patientid: id,
          appointmentid: appointmentid,
        });

        if (result != null) {
          console.log(result)
          setDoctorAssessmentData(result);
        } else {
        }
        dismissLoader()
    } catch (error) {
        console.error("Error in home:", error);
      }
    };

    const formatDate = (dateString) => {
      if (!dateString) return "-";
      return moment(dateString).format("Do MMM, YYYY");
    };

      // console.log(patientid, "treatment plan IDDDDD")
      // console.log(treatmentPlanData, "treatment plan Dataaaaaaa")
  // const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  //   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    
  const addData = () => {
    setFormInputs([{ diagnosisid: null, diagnosis: "", plan: "" }]);
    setDate(moment().format("DD-MM-yyyy"));
    setTime(moment().format("HH:mm"));
    setDefaultDoctor(null);
    setDoctorList([]);
    fetchDoctors(true);
        // setIsAddModalOpen(true);
    addDiagnosisRef.current.openModal();
  }

  const getLocalISOString = (dateStr, timeStr) => {
    // Parse the date in DD-MM-yyyy format
    const [day, month, year] = dateStr.split("-").map(Number);
    // Parse the time in HH:mm format
    const [hours, minutes] = timeStr.split(":").map(Number);
    
    // Create a Date object in local timezone
    const dateObj = new Date(year, month - 1, day, hours, minutes, 0);
    
    // Format to ISO string with local timezone offset
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');
    
    return localISOTime;
  };

  const handledatechange = (selectedDate) => {
    // setIsDateChanged(true)
    // const formattedDate = format(selectedDate, "yyyy-MM-dd");
    const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
    // console.log(formattedDate, "formatted date");
    setDate(formattedDate);
  };

  const handleTimeChange = (event) => {
      const inputTime = event.target.value;
      const currentDate = moment().format("DD-MM-yyyy");
      const currentTime = moment().format("HH:mm");
      
      // Only validate if the selected date is today
      if (date === currentDate) {
        const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
        const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
    
        // Create moment objects for comparison
        const inputMoment = moment().set({
          hour: inputHours,
          minute: inputMinutes,
          second: 0,
          millisecond: 0
        });
        
        const currentMoment = moment();
    
        if (inputMoment.isAfter(currentMoment)) {
          setTime(currentTime);
          showErrorToast("Future time cannot be selected.");
          return;
        }
      }
      
      // If date is not today or time is not in future, update the time
      setTime(inputTime);
    };
  // const handleTimeChange = (event) => {
  //   const inputTime = event.target.value;
  //   console.log(inputTime, "input time");
  //   const currentTime = new Date();
  //   // const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  
  //   const inputDate = new Date();
  //   // inputDate.setHours(inputHours);
  //   // inputDate.setMinutes(inputMinutes);
  
  //   if (inputDate > currentTime) {
      
  //     setTime(moment().format("HH:mm"));
  //     showErrorToast("Future time cannot be selected.");
  //   } else {
  //     setTime(moment().format(inputTime,"HH:mm"));
  //   }
  // };

// Add this helper function
      const [doctorExperience, setDoctorExperience] = useState("");
const getDoctorSpecialties = (doctor) => {
  if (!doctor || !doctor.doctorspeciality || doctor.doctorspeciality.length === 0) {
    return "";
  }
  
  const specialties = doctor.doctorspeciality.map(speciality => {
    if (speciality.specialityname === "Other" && speciality.othervalue) {
      return speciality.othervalue;
    }
    return speciality.specialityname;
  });
  
  return specialties.join(", ");
};
// Update the getDoctorSpecialties function to also handle experience
const getDoctorDetails = (doctor) => {
  if (!doctor) return { specialties: "", experience: "" };
  
  // Get specialties
  const specialties = getDoctorSpecialties(doctor);
  
  // Get experience
  const experience = doctor.experience || "";
  
  return { specialties, experience };
};

  const fetchDoctors = async (shouldSetDefault = false) => {
    showLoader();
    try {
      const result = await FetchUsersByClinic({
        doctorId,
        appointmentid
      });
      if (result.output.result == "success") {
        const doctors = result.output.data;
        setDoctorData(doctors);
        const doctorNames = doctors.map((step) => step.fullname);
        setDoctorList(doctorNames);
          if (shouldSetDefault) {
          const currentDoctor = doctors.find(doc => doc.doctorid == doctorId);
          if (currentDoctor) {
            // Add specialties and experience to the doctor object
          const doctorDetails = getDoctorDetails(currentDoctor);
          const doctorWithDetails = {
            ...currentDoctor,
            specialties: doctorDetails.specialties,
            experience: doctorDetails.experience
          };
          setDefaultDoctor(doctorWithDetails);
          // Also set doctorExperience state separately if needed
          setDoctorExperience(doctorDetails.experience);
          console.log("Default doctor has been set:", doctorWithDetails);

            // Add specialties to the doctor object
          // const doctorWithSpecialties = {
          //   ...currentDoctor,
          //   specialties: getDoctorSpecialties(currentDoctor)
          // };
          // setDefaultDoctor(doctorWithSpecialties);
          //   // setDefaultDoctor(currentDoctor);
          //   console.log("Default doctor has been set:", currentDoctor);
          } else {
            console.log("Could not find the current doctor in the fetched list.", currentDoctor);
          }
        }
      } else {
        setDoctorList([]);
        dismissLoader();
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
    }
  };

  const HandleEditDoctor = (selectedOption)=>{

    const selectedDoctor = doctorData.find(doctor => doctor.fullname === selectedOption);
  if (selectedDoctor) {
    const doctorDetails = getDoctorDetails(selectedDoctor);
    const doctorWithDetails = {
      ...selectedDoctor,
      specialties: doctorDetails.specialties,
      experience: doctorDetails.experience
    };
    setDefaultDoctor(doctorWithDetails);
    // Also update doctorExperience state when doctor changes
    setDoctorExperience(doctorDetails.experience);

  // const doctorWithSpecialties = {
  //     ...selectedDoctor,
  //     specialties: getDoctorSpecialties(selectedDoctor)
  //   };
  //   setDefaultDoctor(doctorWithSpecialties);
    // setDefaultDoctor(selectedDoctor);
  } else {
    setDefaultDoctor(null);
    setDoctorExperience("")
  }
    // let selectedDoctor = doctorData.filter(doctor => doctor.fullname == selectedOption);
    // if (selectedDoctor.length > 0) {
    //   setDefaultDoctor(selectedDoctor[0]);
    // } else {
    //   setDefaultDoctor(null);
    // }
  }

  const handleInputChange = (index, field, value) => {
    const newFormInputs = [...formInputs];
    newFormInputs[index][field] = value;
    setFormInputs(newFormInputs);
  };

  const handleSaveAssessment = async () => {
    // const formattedDate = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    var formattedDate;
    // if(!isDateChanged){
    //   formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    // }else {
    //   formattedDate = date
    // }
    let input = {
      doctorid: doctorId,
      patientid: patientid,
      appointmentid: appointmentid,
      // updateddate: `${formattedDate}T${time}:00`,
      updateddate: getLocalISOString(date, time),
      updatedby: DefaultDoctor?.doctorid,
      doctorsassessment: [{
        diagnosis: formInputs[0].diagnosis,
        plan: formInputs[0].plan,
        diagnosisid: null
      }]
    }
    showLoader()
    try {
      const req = await UpdateDiagnosis(input)
      if (req.output.result === "success") {
        if(appointmentid){
          fetchdoctorassessmentdata(patientid, appointmentid);
        } else {
          fetchdoctorassessmentdata(patientid);
        }
        showSuccessToast("Assessment saved successfully.");
        setFormInputs([{ diagnosisid: null, diagnosis: "", plan: "" }]);
        setDate(moment().format("DD-MM-yyyy"));
        setTime(moment().format("HH:mm"));
        setDefaultDoctor(null);
        setDoctorList([]);
        addDiagnosisRef.current.closeModal();
                // setIsAddModalOpen(false);
      } else {
        showErrorToast("Failed to save assessment.");
      }
    } catch (error){

    } finally {
      dismissLoader();
    }
  }

  const handleEdit = (assessment) => {
    console.log("Edit assessment:", assessment);
    const doctorFromData = doctorData.find(doc => doc.doctorid == assessment.doctorid);
    const doctorDetails = getDoctorDetails(doctorFromData);
    const doctorWithDetails = doctorFromData ? {
      ...doctorFromData,
      specialties: doctorDetails.specialties,
      experience: doctorDetails.experience
    } : { 
      fullname: assessment.doctorname, 
      specialties: "",
      experience: "" 
    };
      
    setDefaultDoctor(doctorWithDetails);
    setDoctorExperience(doctorDetails.experience);

    // Find the doctor from doctorData and get their specialties
    // const doctorFromData = doctorData.find(doc => doc.doctorid == assessment.doctorid);
    // const doctorWithSpecialties = doctorFromData ? {
    //   ...doctorFromData,
    //   specialties: getDoctorSpecialties(doctorFromData)
    // } : { fullname: assessment.doctorname, specialties: "" };
      
    // setDefaultDoctor(doctorWithSpecialties);
    // setDefaultDoctor(assessment.doctorname);
    setDate(moment(assessment.updateddate).format("DD-MM-yyyy"));
    setTime(moment(assessment.updateddate).format("HH:mm"));
    setFormInputs([
      {
        diagnosisid: assessment.id,
        diagnosis: assessment.diagnosis,
        plan: assessment.plan,
      },
    ]);
  // setIsEditModalOpen(true)
    fetchDoctors()
    editDiagnosisRef.current.openModal();
  };

  const handleSaveEdit = async () => {
    // const formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
     var formattedDate;
      // if(!isDateChanged){
      //   formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      // }else {
      //   formattedDate = date
      // }

    let updatedById;
    if (typeof DefaultDoctor === 'string') {
      const doctor = doctorData.find(d => d.fullname === DefaultDoctor);
      if (doctor) {
        updatedById = doctor.doctorid;
      }
    } else {
      updatedById = DefaultDoctor?.doctorid;
    }
    console.log("Updated By ID:", formInputs);
    const input = {
      doctorid: doctorId,
      patientid: patientid,
      appointmentid: appointmentid,
      // updateddate: `${formattedDate}T${time}:00`,
      updateddate: getLocalISOString(date, time),
      updatedby: updatedById,
      doctorsassessment: [{
        diagnosis: formInputs[0].diagnosis,
        plan: formInputs[0].plan,
        diagnosisid: formInputs[0].diagnosisid,
      }]
    };

  showLoader();

  try {
    const req = await UpdateDiagnosis(input);
    if (req.output.result === "success") {
      if(appointmentid){
       await fetchdoctorassessmentdata(patientid, appointmentid);
      } else {
       await fetchdoctorassessmentdata(patientid);
      }      
      showSuccessToast("Assessment updated successfully.");
      editDiagnosisRef.current.closeModal();
  // setIsEditModalOpen(false)
      setFormInputs([{ diagnosisid: null, diagnosis: "", plan: "" }]);
      setDate(moment().format("DD-MM-yyyy"));
      setTime(moment().format("HH:mm"));
      setDefaultDoctor(null);
      setDoctorList([]);
      setIsDateChanged(false);
    } else {
      showErrorToast("Failed to update assessment.");
    }
  } catch (error) {
    console.error("Error in update:", error);
    showErrorToast("Error updating the data.");
  } finally {
    dismissLoader();
  }
};

const openDeleteModal = (id) => {
  setDeleteId(id);
  deleteDiagnosisRef.current.openModal();
};

const handleConfirmDelete = async () => {
  if (!deleteId) return;

  const input = {
    doctorid: doctorId,
    patientid: patientid,
    appointmentid: appointmentid,
    id: deleteId,
    isactive: 0,
  };

  showLoader();
  try {
    const req = await UpdateDiagnosis(input);
    if (req.output.result === "success") {
      if (appointmentid) {
        await fetchdoctorassessmentdata(patientid, appointmentid);
      } else {
        await fetchdoctorassessmentdata(patientid);
      }
      showSuccessToast("Assessment deleted successfully.");
      deleteDiagnosisRef.current.closeModal();
      setDeleteId(null);
    } else {
      showErrorToast("Failed to delete assessment.");
    }
  } catch (error) {
    console.error("Error deleting assessment:", error);
    showErrorToast("Error deleting the assessment.");
  } finally {
    dismissLoader();
  }
};

const correctOrders = async (text) => {
  if (!text) {
    showErrorToast("No text available to correct");
    return;
  }
   // Include doctor specialties in the AI correction request
  const doctorSpecialties = DefaultDoctor?.specialties || "";
  console.log('assesment specialite', doctorSpecialties)
  // const inputToSave = { input: { text } };
  const inputToSave = { input: { text, type: 'Doctor Assessment' } };
//   const inputToSave = {
//     input: {
//       text: currentText,
//       type: `doctor_assessment
// #${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
//     },
//   };
  showLoader();
  try {
    // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
    const result = await CorrectMedicalTermsUsingAI(inputToSave);
    if (result) {
      showSuccessToast("Updated Text");
      return result.text;
    }
  } catch (error) {
    // showErrorToast("Error Happened While Correcting.");
    showErrorToast("Error in Correct AI call.");
  } finally {
    dismissLoader();
  }
};

const handleClutterCorrection = async () => {
  // Correct both diagnosis and plan fields
  const diagnosis = formInputs[0].diagnosis;
  const plan = formInputs[0].plan;
  let newDiagnosis = diagnosis;
  let newPlan = plan;

  if (diagnosis) {
    const correctedDiagnosis = await correctOrders(diagnosis);
    if (correctedDiagnosis) newDiagnosis = correctedDiagnosis;
  }
  if (plan) {
    const correctedPlan = await correctOrders(plan);
    if (correctedPlan) newPlan = correctedPlan;
  }

  setFormInputs([{ ...formInputs[0], diagnosis: newDiagnosis, plan: newPlan }]);
};

    return (
      <>
      {isLoading && <Loader />}
        <Box w="100%" display={{base: "none", lg: "block"}}>
        {appointmentid && (
          <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
            <Text fontWeight='600'>Diagnosis/Treatment Plan</Text>
            <PrimaryButton
              fontSize="14px"
              variant="mdBtn"
              btnIcon="/assets/imgs/add.png"
              buttonText="Add Data"
              onClick={addData}
              // isDisabled={actionAccessPatients?.create ? false : true}
            />
          </Box>
        )}
          {doctorAssessmentData && doctorAssessmentData.length>0 ? (
          <Stepper
            orientation="vertical"
            height='calc(100vh - 160px)'
            overflow='hidden auto'
            padding='1rem'
            size="xs"
            colorScheme="#CDCFD4"
            gap="1rem"
            w="100%"
            justifyContent='flex-start'
          >
              {doctorAssessmentData.map((assessment,index) => (
                assessment.diagnosis && assessment.plan &&
              <Step w="100%" flex='unset' pb="1rem" key={index}>
                <StepIndicator color="#E6E7E9" />
  
                <Box flexShrink="0" flex='unset' w="95%">
                  {/* <StepTitle fontSize="0.875rem" color="#384052" mb="0.5rem">
                    {formatDate(assessment.DATE)}
                  </StepTitle> */}
                  <StepTitle as="div">
                    {appointmentid ? (
                      <Flex justifyContent='space-between' >
                        <Box display='flex' alignItems='center' gap='10px'>
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{
                            assessment.updateddate ? formatDate(assessment.updateddate) : formatDate(assessment.DATE)
                          } </Text>
                          <Box fontSize='10px' bg={assessment.iscurrentvisit === 1 ? '#10b981' : '#d69e2e'} color='white' mb="0.5rem" p='0.25rem 0.5REM' borderRadius='6px'>{assessment.iscurrentvisit === 1 ? 'CURRENT' : 'PAST'}</Box>
                        </Box>
                      </Flex>
                    ) : (
                      <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(assessment.DATE)}</Text>
                    )}
                    <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${assessment.doctorname} , ${assessment.bookingid?assessment.bookingid : ""}`}</Text>
                    <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{assessment.specialization}</Text>      
                  </StepTitle>
                  <StepDescription
                    bg="white"
                    w="100%"
                    border="1px solid #E6E7E9"
                    boxShadow="0px 8px 20px 0px #E6E7E966"
                    borderRadius="0.65rem"
                    p="1.25rem"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      pb="0.5rem"
                    >
                      <Text fontSize="0.875rem" color="#061027">
                        {/* Heart failure with preserved ejection fraction, unspecified HF chronicity (CMS/HCC) */}
                        {/* {treatmentPlanData.diagnosis} */}
                        {assessment.diagnosis}
                      </Text>

                      {assessment.iscurrentvisit === 1 && (
                          <HStack>
                            <Box
                              as="button"
                              onClick={() => handleEdit(assessment)} 
                              bg='white'
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                              >
                              <Image w="13px" src="/assets/imgs/edit-gray.png" />
                            </Box>
                            <Box
                              as="button"
                              onClick={() => openDeleteModal(assessment.id)}
                              bg="white"
                              border="1px solid #E6E7E9"
                              borderRadius="full"
                              w="36px"
                              h="auto"
                              p="10px"
                            >
                              <Image w="13px" src="/assets/svgs/delete.svg" />
                            </Box>
                          </HStack>
                          // <Box
                          //   as="button"
                          //   onClick={() => handleEdit(assessment)} 
                          //   bg='white'
                          //   border="1px solid #E6E7E9"
                          //   borderRadius="full"
                          //   w="36px"
                          //   h="auto"
                          //   p="10px"
                          //   >
                          //   <Image w="13px" src="/assets/imgs/edit-gray.png" />
                          // </Box>
                        )}
                    </Box>
                    <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                      <Text fontSize="0.875rem" fontWeight="500">
                        {/* Plan: Basic metabolic panel, Magnesium */}
                        {/* {treatmentPlanData.plan? "Plan: "+treatmentPlanData.plan:""} */}
                        {assessment.plan}
                      </Text>
                    </Box>
                  </StepDescription>
                </Box>
  
                <StepSeparator />
              </Step>
              ))}
              {/* // )) */}
            
          </Stepper>
        ) : (
          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                            alignItems="center"
                            h="calc(100vh - 100px)"
                          >
                            <Box textAlign="left" fontSize="16px" fontWeight="600">
                              <Image
                                w="26px"
                                opacity="0.5"
                                src="/assets/imgs/treatment-plan.png"
                              />
                            </Box>
                            <Text textAlign="left" fontSize="12px" fontWeight="500">
                              No Data available
                            </Text>
                          </Box>
        )}
        </Box>

        {/* Mobile responsive */}
        <Box w="100%" display={{base: "block", lg: "none"}}>
          <MobileSecondaryNav
            header="Doctor assessment"
            handlebackarrow={backFunction}
          />

          <Box w="100%" h="calc(100vh - 120px)" overflow='hidden auto' p="1rem">
          {doctorAssessmentData && doctorAssessmentData.length>0 ? (
            <Stepper
              orientation="vertical"
              height="400px"
              size="xs"
              colorScheme="#CDCFD4"
              gap="0"
              w="100%"
            >
                {doctorAssessmentData.map((assessment,index) => (
                <Step w="100%" pb="1rem" key={index}>
                  <StepIndicator color="#E6E7E9" />
    
                  <Box flexShrink="0" w="95%">
                    {/* <StepTitle fontSize="0.875rem" color="#384052" mb="0.5rem">
                      {formatDate(assessment.DATE)}
                    </StepTitle> */}
                    <StepTitle as="div">
                      <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(assessment.DATE)}</Text>
                      <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${assessment.doctorname} , ${assessment.bookingid?assessment.bookingid : ""}`}</Text>
                      <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{assessment.specialization}</Text>      
                    </StepTitle>
                    <StepDescription
                      bg="white"
                      w="100%"
                      border="1px solid #E6E7E9"
                      boxShadow="0px 8px 20px 0px #E6E7E966"
                      borderRadius="0.65rem"
                      p="1.25rem"
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        pb="0.5rem"
                      >
                        <Text fontSize="0.875rem" color="#061027">
                          {/* Heart failure with preserved ejection fraction, unspecified HF chronicity (CMS/HCC) */}
                          {/* {treatmentPlanData.diagnosis} */}
                          {assessment.diagnosis}
                        </Text>
                      </Box>
                      <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                        <Text fontSize="0.875rem" fontWeight="500">
                          {/* Plan: Basic metabolic panel, Magnesium */}
                          {/* {treatmentPlanData.plan? "Plan: "+treatmentPlanData.plan:""} */}
                          {assessment.plan}
                        </Text>
                      </Box>
                    </StepDescription>
                  </Box>
    
                  <StepSeparator />
                </Step>
                ))}
                {/* // )) */}
              
            </Stepper>
            ) : (
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                gap="10px"
                alignItems="center"
                h="calc(100vh - 100px)"
              >
                <Box textAlign="left" fontSize="16px" fontWeight="600">
                  <Image
                    w="26px"
                    opacity="0.5"
                    src="/assets/imgs/treatment-plan.png"
                  />
                </Box>
                <Text textAlign="left" fontSize="12px" fontWeight="500">
                  No Data available
                </Text>
              </Box>
          )}
          </Box>
        </Box>

        <DynamicModal
          ref={addDiagnosisRef}
          modalWidth={"40vw"}
          footerStyle={{ p: "0.5rem 1rem" }}
          modalHeight="auto"
          modalHeader="Add Diagnosis / Treatment Plan"
          modalBody={
            <>
              <Flex flexDir='column'>
                <Flex>
                  <DropdownInput
                    variant="leftSide"
                    dropDownPlace="Doctor Name"
                    options={DoctorList}
                    id="Doctor Name"
                    onClick={HandleEditDoctor}
                    value={DefaultDoctor?.fullname} 
                    inputValue={DefaultDoctor?.fullname}
                    // defaultOption={DefaultDoctor}
                    menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                    inputStyleCss={{w: "100%"}}
                  />
                  <Box display="flex" flexDir="row" w="100%">
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handledatechange(selectedDateValue)
                      }
                      defaultDate={date}
                      disableFutureDates={true}
                      placeholderProp="Date"
                      calendarStlye={{left: "-18px",  right: "unset"}}
                      datePickerInputStyle={{borderRadius: '0'}}
                    />

                    <PrimaryInput
                      variant="rightSide"
                      id="vitaltime"
                      inputType="time"
                      inputPlace="Time"
                      pr="10px"
                      defaultValue={time}
                      inputValue={time}
                      onChange={handleTimeChange}
                    />
                  </Box>
                </Flex>

                <PrimaryInput
                  variant="bothSide"
                  inputPlace="Diagnosis"
                  pr="10px"
                  name="doctorsassessment[0].diagnosis"                                                                                               
                  inputValue={formInputs[0].diagnosis}                                                                                                
                  onChange={(e) => handleInputChange(0, "diagnosis", e.target.value)} 
                />
                <Textarea
                  borderRadius='0'
                  name="doctorsassessment[0].plan" 
                  value={formInputs[0].plan} 
                  onChange={(e) => handleInputChange(0, "plan", e.target.value)}
                  height="100%"
                  placeholder="Diagnosis Plan"
                  padding="2"
                  resize="none"
                  style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                />
              </Flex>
            </>
          }

          modalFooterBtn={
            <HStack
              p={2}
              bottom="0"
              width="100%"
              alignItems='center'
            >
              <AssessmentAudioManager
                onTranscriptComplete={(index, field, transcript) => {
                  handleInputChange(index, field, transcript);
                }}
              />
              <Box
    as="button"
    type="button"
    border="1px solid #E6E7E9"
    borderRadius="full"
    w="36px"
    h="auto"
    p="10px"
    display="flex"
    justifyContent="center"
    alignItems="center"
    cursor={(formInputs[0].diagnosis || formInputs[0].plan) ? "pointer" : "not-allowed"}
    opacity={(formInputs[0].diagnosis || formInputs[0].plan) ? 1 : 0.5}
    pointerEvents={(formInputs[0].diagnosis || formInputs[0].plan) ? "auto" : "none"}
    onClick={() => (formInputs[0].diagnosis || formInputs[0].plan) && handleClutterCorrection()}
    // title="Clear the Cutter"
  >
    <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
  </Box>

              <PrimaryButton
                buttonText="Save Assessment"
                onClick={handleSaveAssessment}
                variant='mdBtn'
                btnStyle={{w: "100%"}}
              />    
            </HStack>
          }
        />
        <DynamicModal
          ref={editDiagnosisRef}
          modalWidth={"40vw"}
          footerStyle={{ p: "0" }}
          modalHeight="auto"
          modalHeader="Edit Diagnosis / Treatment Plan"
          modalBody={
            <>
              <Flex flexDir='column'>
                <Flex>
                  <DropdownInput
                    variant="leftSide"
                    dropDownPlace="Doctor Name"
                    options={DoctorList}
                    id="Doctor Name"
                    onClick={HandleEditDoctor}
                    value={DefaultDoctor?.fullname ?? DefaultDoctor} 
                    // defaultOption={DefaultDoctor}
                    menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
                    inputStyleCss={{w: "100%"}}
                  />
                  <Box display="flex" flexDir="row" w="100%">
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handledatechange(selectedDateValue)
                      }
                      defaultDate={date}
                      disableFutureDates={true}
                      placeholderProp="Date"
                      calendarStlye={{left: "-18px",  right: "unset"}}
                      datePickerInputStyle={{borderRadius: '0'}}
                    />

                    <PrimaryInput
                      variant="rightSide"
                      id="vitaltime"
                      inputType="time"
                      inputPlace="Time"
                      pr="10px"
                      defaultValue={time}
                      inputValue={time}
                      onChange={handleTimeChange}
                    />
                  </Box>
                </Flex>

                <PrimaryInput
                  variant="bothSide"
                  inputPlace="Diagnosis"
                  pr="10px"
                  name="doctorsassessment[0].diagnosis"
                  inputValue={formInputs[0].diagnosis}
                  onChange={(e) => handleInputChange(0, "diagnosis", e.target.value)}
                />
                <Textarea
                  borderRadius="0"
                  name="doctorsassessment[0].plan"
                  value={formInputs[0].plan}
                  onChange={(e) => handleInputChange(0, "plan", e.target.value)}
                  height="100%"
                  placeholder="Diagnosis Plan"
                  padding="2"
                  resize="none"
                  style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                />

              </Flex>
            </>
          }

          modalFooterBtn={
            <HStack
              p={2}
              bottom="0"
              width="100%"
              alignItems='center'
            >
              <AssessmentAudioManager
                onTranscriptComplete={(index, field, transcript) => {
                  handleInputChange(index, field, transcript);
                }}
              />
              <Box
      as="button"
      type="button"
      border="1px solid #E6E7E9"
      borderRadius="full"
      w="36px"
      h="auto"
      p="10px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor={(formInputs[0].diagnosis || formInputs[0].plan) ? "pointer" : "not-allowed"}
      opacity={(formInputs[0].diagnosis || formInputs[0].plan) ? 1 : 0.5}
      pointerEvents={(formInputs[0].diagnosis || formInputs[0].plan) ? "auto" : "none"}
      onClick={() => (formInputs[0].diagnosis || formInputs[0].plan) && handleClutterCorrection()}
      // title="Clear the Cutter"
    >
      <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
    </Box>

              <PrimaryButton
                buttonText="Save Assessment"
                onClick={handleSaveEdit}
                variant='mdBtn'
                btnStyle={{w: "100%"}}
              />    
            </HStack>
          }
        />

        <DynamicModal
          ref={deleteDiagnosisRef}
          modalHeader="Delete Assessment?"
          modalBody={
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete this assessment?
            </Text>
          }
          modalFooterBtn={
            <PrimaryButton
              variant='deleteBtn'
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={handleConfirmDelete}
            />
          }
        />
      </>
    );
  };
  
  export default DoctorAssessment;
  